<template>
  <div class="noData">
    <div class="tipsShow">
      <el-image src="../../static/images/icon/nodata.svg" style="width:100px;height:100px;user-select:none;"></el-image>
      <span>{{tips}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props:{
    tips:{
      type:String,
      default:'暂无数据'
    }
  }
}
</script>

<style lang="scss" scoped>
  .noData{
    width:100%;
    height:100%;
    .tipsShow{
      width:100%;
      height:100%;
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
      span{
        font-size:20px;
        color:rgba(0,0,0,0.65);
        user-select:none;
        margin-top:10px;
      }
    }
  }
</style>
